import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { preloadImages } from 'shared/utils';
import supabase from '../../../core/supabase/supabase';
import { GeneralInformation } from '../../domain/interfaces/general-information';
import { getData } from '../../domain/utils/get-data';
import { getGameInfoImageUrls } from '../../domain/utils/get-game-info-image-urls';

const PREFIX = 'gameInfo';

export const resetGameInfo = createAction(`${PREFIX}/resetGameInfo`);

export const syncGameInfo = createAsyncThunk<GeneralInformation, { matchId: number }>(
  `${PREFIX}/syncData`,
  async (payload, { rejectWithValue }) => {
    try {
      const data = await getData(payload.matchId);

      // Прогреваем кэш до fulfilled: оверлей не должен показать доску с ещё не
      // загруженными лого и аватарами. Битые/зависшие картинки отсекаются по таймауту.
      const preload = await preloadImages(getGameInfoImageUrls(data.gameInfo));
      if (preload.failed > 0 || preload.isTimedOut) {
        console.warn({ event: 'Часть изображений не удалось предзагрузить', ...preload });
      }

      return data;
    } catch (error) {
      console.error(`${PREFIX}/fetchUser error:`, error);

      let message;
      if ('message' in (error as Error)) message = (error as Error)?.message;
      else message = String(error);

      supabase.overlayLogs.createError({ comment: 'Не удалось получить данные при синхронизации', message });

      return rejectWithValue(message);
    }
  },
);

export const fetchPassedEvents = createAsyncThunk<number[], { matchId: number }>(
  `${PREFIX}/fetchEvents`,
  async (payload, { rejectWithValue }) => {
    try {
      const data = await supabase.matchChronology.getRow(payload.matchId);
      return data?.chronology.map((event) => event.id) ?? [];
    } catch (error) {
      console.error(`${PREFIX}/fetchEvents error:`, error);

      let message;
      if (error instanceof Error) message = error.message;
      else message = String(error);
      return rejectWithValue(message);
    }
  },
);
